export default {"src":"/_next/static/media/motorola_logo.9e7fb9a1.svg","height":573,"width":2500};